interface ContentfulEntry {
  __typename: string
  key?: string
  value?: ContentfulValue
}

interface ContentfulValue {
  __typename: string
  stringValue?: string
  booleanValue?: boolean
  intValue?: number
  floatValue?: number
  mimeType?: string
  title?: string
  url?: string
  imageUrl?: string | null
  key?: string
  entries?: ContentfulEntry[]
  value?: ContentfulValue
  values?: ContentfulValue[]
}

export const contentfulTemplateMap: { [key: string]: string } = {
  // Landing Page spaces, each has their own space
  alta: '7a5k9v6bcoox',
  fritos: 'eflrdf1wxydu',
  funyuns: '42aepvc7au4i',
  keystone: 'ddf30wlthxsf',
  landingPage: 'nnjady6pcff1',
  northstar: 'nnjady6pcff1',

  // About Us space
  aboutUs: 'dk394eozxr14',
  instagramPosts: 'dk394eozxr14',
  orderBanner: 'dk394eozxr14',
  teamPage: 'dk394eozxr14',

  // Deal.com space
  category: 'qt3sknillzby',
  checkoutBanner: 'qt3sknillzby',
  childCategory: 'qt3sknillzby',
  departmentHeroNoLead: 'qt3sknillzby',
  expertLoggedOutBar: 'qt3sknillzby',
  faq: 'qt3sknillzby',
  openGraphTemplate: 'qt3sknillzby',
  returns: 'qt3sknillzby',

  // Engagement Channels space
  chatTeaser: 'bia1kb6z62po',
  embeddedLandingPage: 'bia1kb6z62po',
  engagementModal: 'bia1kb6z62po',
  fullPageTakeover: 'bia1kb6z62po',
  fullPageTakeoverTeaser: 'bia1kb6z62po',
  productFixedBar: 'bia1kb6z62po',
  searchFullPageTakeover: 'bia1kb6z62po',
  smsModal: 'bia1kb6z62po',

  // Experts Hiring Page space
  brandsPage: 'herory2ot5y9',
  expertsPage: 'herory2ot5y9',

  // Itineraries space
  bannerVariations: 'i2yczzl3oo44',
  itineraryPage: 'i2yczzl3oo44',
  itineraryList: 'i2yczzl3oo44',

  // Paths space
  brooksPathSetup: '8ueigqxvdhp2',
  bubbaPathLayout: '8ueigqxvdhp2',
  roryPathLayout: '8ueigqxvdhp2',
  woodsPathLayout: '8ueigqxvdhp2',

  // topicPage space was deleted from Contentful, but consumer code was kept.
  // Leaving old space id, so nothing yells
  topicPage: 'axtj9owkt1b6'
}

type StringTransformer = (s: string) => string

function extractContentfulValue(
  value: ContentfulValue,
  transform?: StringTransformer
): ContentfulEntry {
  let retValue: any

  switch (value.__typename) {
    case 'ContentBooleanValue':
      retValue = value.booleanValue
      break

    case 'ContentStringValue':
      retValue = transform && value.stringValue ? transform(value.stringValue) : value.stringValue
      break

    case 'ContentIntValue':
      retValue = value.intValue
      break

    case 'ContentFloatValue':
      retValue = value.floatValue
      break

    case 'ContentAsset':
      retValue = {
        mimeType: value.mimeType,
        title: value.title,
        imageUrl: value.imageUrl || value.url
      }
      break

    case 'ContentValueArray':
      if (value.values) {
        retValue = value.values.map(entry => {
          return extractContentfulValue(entry, transform)
        })
      }
      break

    case 'ContentObjectEntry':
      if (value.value) {
        retValue = extractContentfulValue(value.value, transform)
      }
      break

    case 'ContentObject':
      if (value.entries) {
        retValue = value.entries.reduce((accu, value) => {
          if (!value.key || !value.value) {
            return {}
          }

          accu[value.key] = extractContentfulValue(value.value, transform)

          return accu
        }, {} as { [key: string]: ContentfulEntry })
      }
      break
  }

  return retValue
}

export function createContentfulObject(data: ContentfulEntry[], transform?: StringTransformer) {
  let contentfulObject: {
    [key: string]: any
  } = {}

  data.forEach((entry: ContentfulValue) => {
    if (!entry.key || !entry.value) {
      return
    }

    contentfulObject[entry.key] = extractContentfulValue(entry.value, transform)
  })

  return contentfulObject
}
